type PlanType = "essential" | "pro";

type PlanUserType = "owner" | "club_manager";

type FeatureName = "dog_profiles" | "past_results";

type TitleTracker =
  | "AKC Fast CAT"
  | "AKC Rally Obedience"
  | "AKC Obedience"
  | "AKC Scentwork"
  | "AKC Fetch"
  | "UKC Obedience"
  | "UKC Rally Obedience"
  | "UKC Nosework"
  | "All";

interface FeatureConfig {
  quantity: number;
  description: string;
}

type PlanFeatures = {
  [K in PlanType]: {
    [F in FeatureName]: FeatureConfig;
  };
};

const TitleTrackers = {
  AKC_Fast_CAT: "AKC Fast CAT" as TitleTracker,
  AKC_Rally_Obedience: "AKC Rally Obedience" as TitleTracker,
  AKC_Obedience: "AKC Obedience" as TitleTracker,
  AKC_Scentwork: "AKC Scentwork" as TitleTracker,
  AKC_Fetch: "AKC Fetch" as TitleTracker,
  UKC_Obedience: "UKC Obedience" as TitleTracker,
  UKC_Rally_Obedience: "UKC Rally Obedience" as TitleTracker,
  UKC_Nosework: "UKC Nosework" as TitleTracker,
  All: "All" as TitleTracker,
} as const;

const PlanFeaturesConfig: PlanFeatures = {
  essential: {
    dog_profiles: {
      quantity: 1,
      description: "Enhanced Dog Profiles with public sharing"
    },
    past_results: {
      quantity: 1,
      description: "Access to past event results and summaries"
    }
  },
  pro: {
    dog_profiles: {
      quantity: 1,
      description: "Enhanced Dog Profiles with public sharing"
    },
    past_results: {
      quantity: 1,
      description: "Access to past event results and summaries"
    }
  },
};

enum TariffPlanStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  ARCHIVED = "archived"
}

enum BillingPeriod {
  MONTHLY = "month",
  YEARLY = "year",
  ONE_TIME = "one_time",
  USAGE = "usage"
}

enum SubscriptionStatus {
  ACTIVE = "active",
  TRIALING = "trialing",
  PAST_DUE = "past_due",
  CANCELED = "canceled",
  EXPIRED = "expired",
  UNPAID = "unpaid",
  INCOMPLETE = "incomplete",
  INCOMPLETE_EXPIRED = "INCOMPLETE_EXPIRED"
}

/**
 * Who bills the subscription. Records created before in-app purchases have no
 * provider and are Stripe.
 */
enum SubscriptionProvider {
  STRIPE = "stripe",
  APP_STORE = "app_store",
  PLAY_STORE = "play_store",
  /** RevenueCat Test Store, only accepted where EAGERDOG_REVENUECAT_ALLOW_TEST_STORE is on */
  TEST_STORE = "test_store",
}

const STORE_BILLED_PROVIDERS: string[] = [
  SubscriptionProvider.APP_STORE,
  SubscriptionProvider.PLAY_STORE,
  SubscriptionProvider.TEST_STORE,
];

const isStoreBilledSubscription = (subscription?: { provider?: string } | null): boolean =>
  !!subscription?.provider && STORE_BILLED_PROVIDERS.includes(subscription.provider);

export {
  PlanFeaturesConfig,
  PlanType,
  PlanUserType,
  TariffPlanStatus,
  BillingPeriod,
  SubscriptionStatus,
  SubscriptionProvider,
  isStoreBilledSubscription,
  TitleTracker,
  TitleTrackers,
}
